// extracted by mini-css-extract-plugin
module.exports = {"formItem":"EditableTable_formItem__3BOCU","actions":"EditableTable_actions__11Sbt"};